import React, { useEffect, useState } from "react";
import { FieldArray, Formik } from "formik";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import { onPreventEnterSubmitting } from "../../../../../utils/utils";
import SearchUser from "../../../users/users/searchUser";
import * as yup from "yup";
import { DialogActions, Typography } from "@material-ui/core";
import { CustomOutlinedDisabledTextField } from "../../../../../partials/content/Forms";
import {
  getJourneyTeams,
  saveJourneyTeam,
} from "../../../../../services/crm/salesJourney";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../../../../partials/layout/Avatar";
import { Card } from "react-bootstrap";
import { Image } from "react-bootstrap";
import Swal from "sweetalert2";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { FormArrayTextField } from "../../../../../partials/content/Forms/FormField";
function JourneyTeamsForm({ journey = { ID: 0, statusID: 1 } }) {
  const [openSearchUser, setOpenSearchUser] = useState(false);
  const [userSelectedIndex, setUserSelectedIndex] = useState(0);
  const [teams, setTeams] = useState({
    data: [],
  });

  const teamSchema = yup.object().shape({
    data: yup.array().of(
      yup.object().shape({
        ID: yup.number(),
        userID: yup.number(),
        userName: yup.string().required("Sales Name is required"),
        description: yup.string(),
      })
    ),
  });
  useEffect(() => {
    getJourneyTeamsData(journey.ID);
  }, [journey.ID]);
  return (
    <React.Fragment>
      <Formik
        initialValues={teams}
        enableReinitialize={true}
        validateOnChange={false}
        validationSchema={teamSchema}
        onSubmit={async (values, { resetForm, setStatus, setSubmitting }) => {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title: "Are you sure want to save this Journey Team ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveJourneyTeam(values.data).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  getJourneyTeamsData(journey.ID);
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        {({
          dirty,
          values,
          status,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          isSubmitting,
        }) => (
          <form
            autoComplete="off"
            className="kt-form"
            onSubmit={handleSubmit}
            onKeyDown={onPreventEnterSubmitting}
          >
            <FieldArray name="data">
              {({ push, remove }) => (
                <React.Fragment>
                  <Card>
                    <Card.Header>
                      <i className="fas fa-users"></i>
                      <span>
                        <strong>Sales Journey Teams</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      {journey.statusID !== 3 && journey.statusID !== 9 ? (
                        <div className="row mb-3">
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <button
                              type="button"
                              className="btn btn-primary btn-md btn-pill btn-bold"
                              onClick={() => {
                                push({
                                  ID: 0,
                                  journeyID: journey.ID,
                                  statusID: 1,
                                  userID: 0,
                                  userName: "",
                                  delFlag: false,
                                  user: {
                                    userImage: [],
                                  },
                                });
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              Add Team Member
                            </button>
                            {dirty ? (
                              <button
                                type="submit"
                                className="btn btn-success btn-md btn-pill btn-bold"
                                style={{ marginLeft: "5px" }}
                              >
                                <i className="fas fa-save"></i>
                                Save
                              </button>
                            ) : null}
                          </div>
                        </div>
                      ) : null}
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <div className="row">
                            {values.data && values.data.length > 0
                              ? values.data.map((item, index) => (
                                  <React.Fragment key={index}>
                                    <div className="col-sm-3 col-md-3 col-lg-3">
                                      <Card className="text-center my-2">
                                        <Card.Header>
                                          {item.user.userImage ? (
                                            <Typography align="center">
                                              <Image
                                                src={
                                                  item.user.userImage.length ===
                                                  0
                                                    ? createImageFromInitials(
                                                        150,
                                                        item.userName,
                                                        getRandomColor()
                                                      )
                                                    : item.user.userImage[0]
                                                        .imagePath
                                                }
                                                style={{
                                                  maxHeight: "100px",
                                                }}
                                                alt="Avatar"
                                                roundedCircle
                                                fluid
                                              />
                                            </Typography>
                                          ) : null}
                                          {item.userID === journey.salesID ||
                                          item.userID ===
                                            journey.createdBy ? null : (
                                            <div className="row justify-content-center image-button-container-theme">
                                              <div className="col-sm-12 col-md-12 col-lg-12">
                                                <Typography align="center">
                                                  <BootstrapTooltip
                                                    title={
                                                      item.ID > 0 &&
                                                      item.delFlag
                                                        ? "Undo Delete"
                                                        : "Delete User"
                                                    }
                                                  >
                                                    <button
                                                      type="button"
                                                      className={`btn btn-icon btn-label-${
                                                        item.ID > 0 &&
                                                        item.delFlag
                                                          ? "warning"
                                                          : "danger"
                                                      } btn-md btn-circle mx-1 image-button-theme`}
                                                      onClick={() => {
                                                        if (item.ID > 0) {
                                                          setFieldValue(
                                                            `data[${index}].delFlag`,
                                                            !item.delFlag
                                                          );
                                                        } else {
                                                          remove(index);
                                                        }
                                                      }}
                                                    >
                                                      {item.ID > 0 &&
                                                      item.delFlag ? (
                                                        <i className="fas fa-undo-alt"></i>
                                                      ) : (
                                                        <i className="fas fa-trash-alt"></i>
                                                      )}
                                                    </button>
                                                  </BootstrapTooltip>
                                                </Typography>
                                              </div>
                                            </div>
                                          )}
                                        </Card.Header>
                                        <Card.Body>
                                          <div className="row">
                                            <div className="col-sm-12 col-md-12 col-lg-12">
                                              {item.userID ===
                                                journey.salesID ||
                                              item.userID ===
                                                journey.createdBy ? (
                                                <CustomOutlinedDisabledTextField
                                                  label="Sales Name"
                                                  value={item.userName}
                                                />
                                              ) : (
                                                <FormArrayTextField
                                                  label="Sales Name"
                                                  arrayPropName="data"
                                                  index={index}
                                                  propName="userName"
                                                  searchButton
                                                  readonly
                                                  onSearchClick={() => {
                                                    setUserSelectedIndex(index);
                                                    setOpenSearchUser(true);
                                                  }}
                                                />
                                              )}
                                              {item.userID ===
                                                journey.salesID ||
                                              item.userID ===
                                                journey.createdBy ? (
                                                <CustomOutlinedDisabledTextField
                                                  label="Role Description"
                                                  value={item.description}
                                                />
                                              ) : (
                                                <FormArrayTextField
                                                  label="Role Description"
                                                  arrayPropName="data"
                                                  index={index}
                                                  propName="description"
                                                />
                                              )}
                                            </div>
                                          </div>
                                        </Card.Body>
                                      </Card>
                                    </div>
                                  </React.Fragment>
                                ))
                              : null}
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </React.Fragment>
              )}
            </FieldArray>
            <DialogLayout
              open={openSearchUser}
              title="Search User"
              onCloseDialog={handleCloseSearchUser}
              maxWIdth="lg"
            >
              <SearchUser
                onSelectUser={(user) => {
                  setFieldValue(`data[${userSelectedIndex}].userID`, user.ID);
                  setFieldValue(
                    `data[${userSelectedIndex}].userName`,
                    user.firstName + " " + user.lastName
                  );
                  handleCloseSearchUser();
                }}
              />
              <DialogActions>
                <button
                  type="button"
                  className="btn btn-label-danger btn-md btn-pill btn-bold"
                  onClick={handleCloseSearchUser}
                >
                  <i className="fas fa-window-close"></i>
                  Close
                </button>
              </DialogActions>
            </DialogLayout>
          </form>
        )}
      </Formik>
    </React.Fragment>
  );
  async function getJourneyTeamsData(journeyID) {
    const response = await getJourneyTeams(journeyID);
    const { data } = response.data;
    setTeams({ data: data.teams });
  }
  function handleCloseSearchUser() {
    setOpenSearchUser(false);
  }
}

export default JourneyTeamsForm;
